(() => {
  function isTargetWidget(node) {
    if (!(node instanceof HTMLElement)) return false;

    const fingerprint = [
      node.tagName,
      node.id || '',
      String(node.className || ''),
      node.getAttribute('aria-label') || '',
      node.getAttribute('title') || '',
      node.getAttribute('src') || '',
      node.getAttribute('data-testid') || '',
    ]
      .join(' ')
      .toLowerCase();

    const looksLikeShopifyForms = /(shopify\/forms|shopify-form|shopify forms|shopifycloud|myshopify\.com\/services\/forms)/.test(
      fingerprint
    );
    const looksLikeDiscountCouponIframe =
      node.tagName === 'IFRAME' && /(discount|coupon)/.test(fingerprint);

    return looksLikeShopifyForms || looksLikeDiscountCouponIframe;
  }

  function isFloatingOrEdgeWidget(node) {
    if (!(node instanceof HTMLElement)) return false;

    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const isFloatingPosition = ['fixed', 'sticky', 'absolute'].includes(style.position);
    if (node.tagName === 'IFRAME' && isFloatingPosition) return true;
    if (isFloatingPosition) return true;

    const rect = node.getBoundingClientRect();
    const nearEdge =
      rect.left <= 48 ||
      rect.right >= window.innerWidth - 48 ||
      rect.top <= 48 ||
      rect.bottom >= window.innerHeight - 48;

    return nearEdge;
  }

  function hideWidget(node) {
    if (!(node instanceof HTMLElement)) return;
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('opacity', '0', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
  }

  function hideAudienceBlockedWidgets() {
    const nodes = document.querySelectorAll('body *');
    nodes.forEach((node) => {
      if (!isTargetWidget(node)) return;
      if (!isFloatingOrEdgeWidget(node)) return;
      hideWidget(node);
    });
  }

  function init() {
    const audience = window.customerAudience || {};
    const isLoggedIn = Boolean(audience.isLoggedIn);
    const ordersCount = Number(audience.ordersCount || 0);
    const hasPurchased = ordersCount >= 1;

    // Hide for: logged-in users OR customers with at least one order.
    const shouldHide = isLoggedIn || hasPurchased;
    if (!shouldHide) return;

    hideAudienceBlockedWidgets();

    const observer = new MutationObserver(() => {
      hideAudienceBlockedWidgets();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'id', 'src', 'title', 'aria-label'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
